import { render } from "./BlockDashboard.vue?vue&type=template&id=770a0338&scoped=true"
import script from "./BlockDashboard.vue?vue&type=script&lang=js"
export * from "./BlockDashboard.vue?vue&type=script&lang=js"

import "./BlockDashboard.vue?vue&type=style&index=0&id=770a0338&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770a0338"]])

export default __exports__